var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-headful',{attrs:{"title":_vm.page.header.title,"description":_vm.page.header.description,"keywords":_vm.page.header.keywords}}),_c('NavBar'),_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"moveInUp"}},[_c('router-view')],1)],1),_c('Footer'),_c('Metriks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }